import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { HANDLE_GET_ANALYTICS } from "./action.types";
import { setData, setLoading } from "./reducer";
import { RootState } from "store/store";
import { ANALYTIC_METRIC_ARRAY } from "lib/Constants";
import {  ANALYTIC_METRIC_TYPE, TOAST_TYPES } from "enum/enums";
import { addToast } from "store/toaster/reducer";
import { handleErrorMessage } from "lib/utils";
import { getAnalytics } from "services/analyticService";

export function* handleGetAnalytics(action: { type: string; payload: { startDate: string; endDate: string } }): Generator {
  const {
    payload: { startDate, endDate },
  } = action;

  yield put(setLoading(true));

  try {
    const authState: any = yield select((state: RootState) => state.auth);
    const tenantId: string | undefined = authState?.selectedTenant?.tenantId;

    if (!tenantId) {
      yield put(setData({}));
      yield put(
        addToast({
          type: TOAST_TYPES.ERROR,
          messsage: "Unable to fetch analytics without a selected tenant.",
        }),
      );
      return;
    }

    // 👇 Run all analytics API calls in parallel, safely
    const results: any[] = (yield all(
      ANALYTIC_METRIC_ARRAY.map((metric) =>
        call(safeCall, getAnalytics, { tenantId, metric: metric as ANALYTIC_METRIC_TYPE, startDate, endDate })
      )
    )) as any[];
    // ✅ Check if any succeeded
	const modifiedResults = results.reduce((acc, curr,index) => {
		if (curr.status === "fulfilled") {
			acc[ANALYTIC_METRIC_ARRAY[index]] = curr.value?.data?.data ?? curr.value;
		}
		return acc;
	}, {});
	yield put(setData(modifiedResults));
  } catch (error) {
    yield put(setData({}));
    yield put(addToast({ type: TOAST_TYPES.ERROR, messsage: handleErrorMessage(error) }));
  } finally {
    yield put(setLoading(false));
  }
}

export function* safeCall(fn: any, ...args: any[]): any {
  try {
    const response = yield call(fn, ...args);
    console.log("✅ API success:", args?.[0]?.metric ?? "", response);
    return { status: "fulfilled", value: response };
  } catch (err) {
    console.error("❌ API failed:", args?.[0]?.metric ?? "", err);
    return { status: "rejected", reason: err };
  }
}

function* analyticSaga() {
	yield takeLatest(HANDLE_GET_ANALYTICS, handleGetAnalytics);
}
export default analyticSaga;
